import type { FantasyScreenName } from '~/types/fantasy'

export const FANTASY_LIST_PATH = '/fantasy/all'

export const FANTASY_SCREENS = {
  all: 'fantasy_all',
  main: 'fantasy_main',
  shop: 'fantasy_shop',
  collection: 'fantasy_collection',
  gameDay: 'fantasy_game_day',
  pickPlayer: 'fantasy_pick_player',
  leaderboardDay: 'fantasy_leaderboard_day',
  leaderboardSeason: 'fantasy_leaderboard_season',
  setBuy: 'fantasy_set_buy',
  setAdded: 'fantasy_set_added',
  cardSold: 'fantasy_card_sold',
  cardBuy: 'fantasy_card_buy',
  sellConfirm: 'fantasy_sell_confirm',
  upgradeConfirm: 'fantasy_upgrade_confirm'
} as const satisfies Record<string, FantasyScreenName>
